export var LOADING = 'Loading';
//# sourceMappingURL=loading.js.map